import {
  FieldChange,
  FieldHistoryLog,
  FieldHistoryLogQueries,
  RecordType,
} from '@/graphql/queries/fieldHistoryLogs/fieldHistoryLogs.queries'
import { useGraphql } from '@/hooks/useGraphql'
import { compareDates } from '@/util'

export interface Record {
  id: number
  recordType: RecordType
}

export const useFieldHistoryLogs = ({ record, enabled }: { enabled?: boolean; record: Record }) => {
  const { data, ...fieldHistoryLogsQuery } = useGraphql<FieldHistoryLogQueries.GET.Response>(
    FieldHistoryLogQueries.QUERY_KEY,
    FieldHistoryLogQueries.getFieldHistoryLogs(),
    { record: { ...record } },
    { enabled },
  )

  const fieldHistoryLogsData: FieldChangeRow[] = data?.fieldHistoryLogs
    ? transformedFieldHistoryLogs(data?.fieldHistoryLogs)
    : []

  fieldHistoryLogsData.sort((a, b) => compareDates(a.modifiedAt, b.modifiedAt))

  return {
    ...fieldHistoryLogsQuery,
    data,
    fieldChangeRows: fieldHistoryLogsData,
  }
}

const transformedFieldHistoryLogs = (fieldHistoryLogs: FieldHistoryLog[]) => {
  return fieldHistoryLogs.reduce((prev, fieldHistoryLog) => {
    const logs: FieldChangeRow[] = []
    fieldHistoryLog.fieldChanges?.forEach((log) => {
      if (log.field_name !== 'updated_at' && log.field_name !== 'last_modified_by' && (log.new || log.old)) {
        logs.push({ ...log, userName: fieldHistoryLog.user.fullName, modifiedAt: fieldHistoryLog.modifiedAt })
      }
    })
    return [...prev, ...logs]
  }, [])
}

interface FieldChangeRow extends FieldChange {
  modifiedAt: string
  userName: string
}
